import React, { useEffect, useState } from "react";
import { GetApi } from "../api/api-service";
import { API_Path, imgBaseUrl } from "../Const";
import styles from "../style/blog.module.css";
import { Link, useNavigate, useParams } from "react-router";
import { MdDateRange } from "react-icons/md";
import { onError } from "../components/CommonFun";
import NoPropertyImg from "../images/no_property.png";
import NoBlogImg from "../images/inactive_blog.png";
const RECENT_BLOGS = [
    {
        id: 1,
        badge: "VISA",
        badgeClass: "badgeVisa",
        title: "How to Renew Visit Visa in UAE [2026 Edition] & Fees Explained",
        date: "May 22, 2026",
        img: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=200&q=80",
    },
    {
        id: 2,
        badge: "MARKET UPDATE",
        badgeClass: "badgeMarket",
        title: "Dubai Real Estate Market Trends to Watch in 2026",
        date: "May 18, 2026",
        img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=200&q=80",
    },
    {
        id: 3,
        badge: "BUYING GUIDE",
        badgeClass: "badgeBuying",
        title: "Step-by-Step Guide to Buying Property in Dubai",
        date: "May 16, 2026",
        img: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=200&q=80",
    },
    {
        id: 4,
        badge: "INVESTING",
        badgeClass: "badgeInvesting",
        title: "Why Off-Plan Properties Are a Smart Investment in 2026",
        date: "May 14, 2026",
        img: "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=200&q=80",
    },
    {
        id: 5,
        badge: "LEGAL & FINANCE",
        badgeClass: "badgeLegal",
        title: "Understanding Dubai's Real Estate Laws for Expats",
        date: "May 10, 2026",
        img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=200&q=80",
    },
    {
        id: 6,
        badge: "LIFESTYLE",
        badgeClass: "badgeLifestyle",
        title: "Best Family-Friendly Communities in Dubai for 2026",
        date: "May 9, 2026",
        img: "https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=200&q=80",
    },
];
export default function BlogDetails() {
    const [isLoader, setIsLoader] = useState(false);
    const [blogDetail, setBlogDetail] = useState({});
    const navigate = useNavigate();
    const { slug, id } = useParams();

    useEffect(() => {
        if (slug) {
            if (id) {
                fatchBlogList(id);
            }
        } else navigate("/");
    }, [slug]);


    const fatchBlogList = async (id) => {
        try {
            setIsLoader(true);
            let res = await GetApi(`${API_Path.blogDetail}${id}?api-version=1`);
            if (res && res.data.success) {
                let data = res.data.data;
                if (data) {
                    data = Object.fromEntries(Object.entries(data).filter((item) => !item?.isActive));
                    setBlogDetail(data);
                } else setBlogDetail({});
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };
    return (
        <div className={styles.details}>
            <div className="container">
                <div className="row">
                    {Object.values(blogDetail).length == 0 ? (
                            <div className="position-relative">
                                <img src={NoBlogImg} className="img-fluid" alt="" />
                                <div className={styles.inactive_btn}>
                                    <Link to="/blog">
                                        <button className="button">Blog</button>
                                    </Link>
                                </div>
                            </div>
                    ) : (
                        <>
                            <div className="col-9">
                                <section className={styles.section_content}>
                                    <div className={styles.details_img}>
                                        <img
                                            src={blogDetail?.blogImageUrl ? `${imgBaseUrl}${blogDetail?.blogImageUrl}` : NoPropertyImg}
                                            alt={blogDetail?.name}
                                            onError={(e) => {
                                                onError(e);
                                            }}
                                        />
                                    </div>
                                    <div className={styles.title}>
                                        <h1>{blogDetail?.name}</h1>
                                    </div>
                                    <div className={styles.details_date}>
                                        <span>
                                            <MdDateRange /> {blogDetail?.created}
                                        </span>
                                    </div>
                                    <div className={styles.details_content} dangerouslySetInnerHTML={{ __html: blogDetail?.description }}></div>
                                </section>
                            </div>
                            <div className="col-3">
                                <div className={styles.recentCard}>
                                    <div className={styles.recentHeader}>
                                        <h3 className={styles.recentTitle}>
                                            <span className={styles.recentTitleDot} />
                                            Recent Blogs
                                        </h3>
                                    </div>
                                    <ul className={styles.recentList}>
                                        {RECENT_BLOGS.map((post) => (
                                            <li key={post.id} className={styles.recentItem}>
                                                <div className={styles.recentThumbWrap}>
                                                    <img className={styles.recentThumb} src={post.img} alt={post.title} />
                                                </div>
                                                <div className={styles.recentInfo}>
                                                    <span className={`${styles.recentBadge} ${styles[post.badgeClass]}`}>{post.badge}</span>
                                                    <p className={styles.recentItemTitle}>{post.title}</p>
                                                    <div className={styles.recentMeta}>
                                                        <span>
                                                            <MdDateRange /> {post.date}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className={styles.ctaCard}>
                                    <h3 className={styles.ctaTitle}>Thinking of buying or investing?</h3>
                                    <p className={styles.ctaSub}>Our property experts are here to help you make the right move.</p>
                                    <Link to="/agents">
                                        <button className={styles.ctaBtn}>Talk to an Expert →</button>
                                    </Link>
                                </div>
                                <div className={styles.helpCard}>
                                    <div className={styles.helpCardTop}>
                                        <div className={styles.helpIcon}>
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M3 18v-6a9 9 0 0118 0v6" />
                                                <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z" />
                                            </svg>
                                        </div>
                                        <h4 className={styles.helpTitle}>Still Need Help?</h4>
                                    </div>
                                    <p className={styles.helpText}>Can't find the answer you're looking for? Our support team is here to help you.</p>
                                    <Link to="/contact-us">
                                        <button className="button w-100">Contact Support →</button>
                                    </Link>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
